<div class="login-content">
  @if (successMessage) {
    <div class="snackbar snackbar-green justify-center">
      {{ successMessage }}
    </div>
  }
  @if (errorMessage) {
    <div class="snackbar snackbar-red justify-center">{{ errorMessage }}</div>
  }
  <div class="page-title">
    <span class="font-medium-display-small text-center">
      Melde dich an und lerne weiter
    </span>
  </div>
  <form
    class="flex-c form-content"
    [formGroup]="loginForm"
    (ngSubmit)="login()">
    <div class="form-group">
      <label class="input-label" for="email">E-Mail</label>
      <input
        (keyup)="removeErrors($event)"
        type="email"
        class="form-control input-text"
        [class]="{
          'input-error':
            loginForm.get('email').invalid && loginForm.get('email').touched,
          'input-success':
            loginForm.get('email').valid && loginForm.get('email').touched,
        }"
        id="email"
        formControlName="email"
        placeholder="E-Mail"
        autocomplete="email" />
      <!-- Error Messages -->
      <app-error-message
        [formField]="loginForm.get('email')"></app-error-message>
      <label class="input-label" for="password">Passwort</label>
      <div class="password-input-wrapper">
        <input
          (keyup)="removeErrors($event)"
          [type]="showPassword ? 'text' : 'password'"
          class="form-control input-text"
          [class]="{
            'input-error':
              loginForm.get('password').invalid &&
              loginForm.get('password').touched,
            'input-success':
              loginForm.get('password').valid &&
              loginForm.get('password').touched,
          }"
          id="password"
          formControlName="password"
          placeholder="Passwort"
          autocomplete="current-password" />
        <button
          type="button"
          class="password-toggle-button"
          (click)="togglePasswordVisibility()"
          [attr.aria-label]="
            showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'
          ">
          <i
            [class]="
              showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'
            "></i>
        </button>
      </div>
      <!-- Error Messages -->
      <app-error-message
        [formField]="loginForm.get('password')"></app-error-message>
    </div>
    @if (notVerified) {
      <button
        type="button"
        [disabled]="loginForm.invalid"
        (click)="resendVerificationEmail()"
        class="inwi-text-button-large-secondary">
        <div class="button-content">
          <i class="fa-regular fa-envelope"></i>
          <span class="button-text">Verifizierungs-Mail erneut senden</span>
        </div>
      </button>
    }
    <div class="form-button flex-c">
      <button type="submit" class="inwi-text-button-large-primary">
        Anmelden
      </button>
      <button
        type="button"
        (click)="route('./forgot')"
        class="inwi-text-button-large">
        Passwort vergessen
      </button>
    </div>
  </form>
</div>
